import { render, staticRenderFns } from "./countryStatus.vue?vue&type=template&id=f740ea6c&"
import script from "./countryStatus.vue?vue&type=script&lang=js&"
export * from "./countryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports